import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Link } from "./little_router";

// Composes Link (rather than extending it) — the local Link is a connected component,
// not a base class. Active state compares the link's section to the current URL's section.
const BasePathActiveLink = (props) => {
  const customIsActive = props.href.split("/")[1] === location.pathname.split("/")[3];

  return (
    <Link {...props} className={classNames({ active: customIsActive })} />
  );
};

BasePathActiveLink.propTypes = {
  href: PropTypes.string.isRequired,
};

export default BasePathActiveLink;
